module.exports = __webpack_public_path__ + "img/framboise_creme.a8232899.jpg";